module.exports={
  message: {
    common:
    {
		update_successfully: '更新成功'
    },
    header:
    {
		alarm: '报警',
		see_alarm: '查看所有报警',
		search: '搜索',
		user_name: '用户名',
		setting: '帐号设置',
		logout: '退出',
		API:"API",
    },
    left:
    {
		navigation: '导航',
		dashboard: '仪表盘',
		live: '实时视频',
		playback: '回放',
		AdvancePB:'高级回放',
		archive:'归档',
		screenshots:"文件夹",
		snapshot: '抓图',
		event:"事件",
		setting: '设置',
		tour:"巡更",
		cloud: '云视频',
		logout: '退出',
		camera:"监控点",
		VideoConference:"视频会议",
    },
    login:
    {
		high_perf: '高性能HTML5原生视频',
		signin: '登录到管理界面',
		login: '登录',
		login_status_failed: '用户名或密码不正确',
		username: '用户名',
		password: '密码',
		language: '语言选择'
    },
	dashboard:
    {
		about:"关于",
		dashboard: '仪表盘',
		system_info: '系统',
		version: '版本',
		hostid: '主机号',
		license: '版权',
		channel: '通道',
		endtime: '版权结束时间',
		memory: '内存',
		running: '运行',
		network_in: '网络进流量',
		network_out: '网络出流量',
		free_space: "剩余空间",
		an_out:"网络进出流量",
		online_cam: "在线摄像机",
		cameras: "摄像机总数",
		total_space: "总空间",	
		version_: '版本',
		codec_info: "编解码器",
		GPU_info: "GPU编解码器",
		cpumodel: 'CPU型号',
		PhysicalCPU:"CPU路数",
		CPUCore:"CPU核数",
		gpuencoder:"GPU编码器",
		gpudecoder:"GPU解码器",
		cpuencoder:"软件编码器",
		cpudecoder:"软件解码器",
		capability:"功能列表",
		devicesdk:"设备SDK",
		device:"设备",
		devicesdkpb:"设备SDK回放",
		gb28181:"国标",
		transcoding:"转码",
		VideoConference:"视频会议",
		cluster:"集群",
		Online:"在线",
		Not_nline:"不在线",
		Platform:"平台",
		Hikvision:"海康SDK",
		Dahua:"大华SDK",
		Tiandy:"天地SDK",
		DiskMemory:"硬盘/内存",
		TotalMemory:"总内存",
		total:"共",
		ge:"个",
		Cloud:"云级联",
		RTMP:"RTMP推流",
		Online:"在线",
		Offline:"离线",

    },
	live:
    {
		liveview: '实时视频',
		device: '视频源',
		setting: '设置',
		protocol: '协议',
		mainstream:'主码流',
		substream:"辅码流",
		camera:"摄像机",
		waterprint:"水印",
		Videorecording:"正在录像",
		Region:"区域",
		Scan:"扫扫查看视频",
		Quality:"画质",
		Switched:'已切换'
		
    },
    setting:
    {
		Default:"默认",
		Transcoding:"转码管理",
		Profile:"自定义",
		setting: '设置',
		device: '设备',
		record:"录像管理",
		devicesdk: '设备SDK',
		devicertmppush: 'RTMP推流',
		Regional:"区域管理",
		Please:"请输入名字",
		Area:"区域删除/添加",
		Input:"输入框不能为空",
		user: '用户',
		role: '角色',
		action: '操作',
		edit: '编辑',
		name: '名字',
		currentpass: '当前密码',
		newpass: '新密码',
		confirmpass: '新密码确认',
		manualstart:"开启所有通道录像",
		manualstop:"关闭所有通道录像",
		DeleteAll:"删除",
		Detail:"查看",
		Cancel:"取消",
		OK:"确定",
		Configuration:"配置",
		ADD:"添加",
		Change:"修改密码",
		Changecg:"修改成功，请重新登陆！",
		Changesb:"修改失败！",
		Twopassword:"两次密码不一致，请重新输入!",
		all:"全部",
		Editorfailure:"编辑失败",
	},
	table:{
		Token:"编号",
		Type:"类型",
		Online:"在线状态",
		Edit:"编辑",
		Index:"序号",
		GBID:"国标ID",
		IP:"IP地址",
		Name:"名称",
		Port:"端口",
		User:"用户名",
		UUID:"事件编号",
		Time:"时间",
		Detaill:"详细",
		Tokenevent:"设备编号",
		StartTime:"开始时间",
		EndTime:"结束时间",
		Codec:"视频编码",
		Engine:"引擎",
		FPSType:"帧率类型",
		ScaleType:"分辨率类型",
	},
	playback:{
		H5SPlayback:"H5S回放",
		NVRPlayback:"NVR回放",
	},
	GB:{
		name: '名字',
		GB28181:"国标",
		GBPlatform:"国标平台",
		Name:"名字",
		SIPServerIP:"SIP服务器地址",
		SIPServerPort:"SIP服务器端口",
		SIPPort:"本地SIP端口",
		SIPUserID:"SIP用户ID",
		SIPServerID:"SIP服务器ID",
		Password:"密码",
		SIPProtocol:"SIP协议",
		SIPChannelBaseID:"起始通道编码",
		RegisterPeriod:"注册有效期",
		KeepaliveTime:"心跳周期",
		Domain:"服务器域",
		Refreshsuccess:"刷新成功",
		Restartsuccessfully:"重启成功",


		DeleteAll:"删除",
		Detail:"查看",
		Cancel:"取消",
		OK:"确定",
		Configuration:"配置",
		OVER:"全部",
		ADD:"添加",
		edit: '编辑',
	},
	archive:{
		search: '搜索',
		archive:'归档',
		StartTime:"开始时间",
		EndTime:"结束时间",
		ManualRecord:"手动录像",
		AlarmRecord:"报警录像",
		Schedulerecord:"计划录像",
		Refresh:"刷新",
		Download:"下载",
		Playback:"视频回放",
		Name:"名称",
		snapshot: '抓图',
		Clear:"清空",
		Onehour:"最近一小时",
		Oneday:"最近一天",
		Oneweek:"最近一周",
		Onemonth:"最近一个月",
		Time:"截图时间",
		Preview:"预览",
		Picture:"图片",
		Pleaseselectone:"请选择一个",
	},
	tour:{
		Start:"开始",
		stop:"停止",
	},
	camera:{
		Save_successfully:"保存成功！",
		// Editor_failure:"保存失败！",
		Delete_successful:"删除成功！",
		Delete_failed:"删除失败！",
		open_Close:"开启/关闭",
		name: "名称",
		audio:"音频" ,
		save:"保存",
	},
	Conference:{
		VideoConference:"视频会议",
		Call:"通话",
		VideoCall:"接通视频",
		AudioCall:"接通语音",
		HangUp:"挂断",
		Hang:"挂断",
		JoinConference:"加入会议",
		Nickname:"昵称不能为空!",
	}
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/lang/zhchs.js
// module id = 7afD
// module chunks = 1